<template>
  <q-btn-dropdown
    v-if="isGranted('VIEW_POST_IMPORT_FILE_NAME')"
    icon="fa fa-file"
    title="File name"
    rounded
    flat
  >
    <q-list>
      <q-item>
        <q-item-section>{{ fileName }}</q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { isGranted } from '@/social/auth';

export default defineComponent({
  props: {
    fileName: {
      type: String,
      required: true,
    },
  },
  methods: {
    isGranted,
  },
});
</script>
